module.exports = __webpack_public_path__ + "static/img/m_role.868e35d.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/tsz/m_role.png
// module id = qB1p
// module chunks = 7